// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RzKc","col":"styles_col__B8cgW","actions":"styles_actions__3Eami","conflict":"styles_conflict__3ctuw"};